//This will be pixel value
export const mobileTopBarHeight = 59;
export const tabletTopBarHeight = 84;
export const mobileAccountHeight = 85;
export const desktopAccountHeight = 89;
export const desktopLogoHeight = 90;
export const mobileBreadcrumbHeight = 61;
